module.exports = __webpack_public_path__ + "static/media/event_grey.e889df44.png";